'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { toggleCardContentStyles } from './styles/toggle-card-root-content.styles';
import type { ToggleCardRootContentPropsInterface } from './types/toggle-card-root-content.types';

export const ToggleCardRootContent = forwardRef<
  HTMLDivElement,
  ToggleCardRootContentPropsInterface
>((props: ToggleCardRootContentPropsInterface, forwardedRef) => {
  const { children, className, css: cssProp, ...rest } = props;

  const styles = css(toggleCardContentStyles, cssProp);

  return (
    <div
      ref={forwardedRef}
      data-c11n-component="ToggleCard.RootContent"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', 'c11n_toggle-card__root-content', styles, className)}
      {...rest}
    >
      {children}
    </div>
  );
});

ToggleCardRootContent.displayName = 'ToggleCard.RootContent';
